import { Accordion } from '@squareup/dex-ui';
import { Box, Paragraph20 } from '@squareup/dex-ui-shared-base';
import React, { FC, PropsWithChildren } from 'react';

interface MdxAccordionProps {
  title?: string;
}

const MdxAccordion: FC<PropsWithChildren<MdxAccordionProps>> = ({
  title,
  children,
}) => {
  return (
    <Accordion
      title={
        <Paragraph20 as="span" weight="semi-bold">
          {title || ''}
        </Paragraph20>
      }
      defaultExpanded={false}
      trackingId="mdx-accordion-clicked"
      padding={{ vertical: '2x' }}
    >
      {children}
    </Accordion>
  );
};

MdxAccordion.displayName = 'MdxAccordion';

const MdxAccordionGroup: FC<PropsWithChildren> = ({ children }) => {
  return <Box>{children}</Box>;
};

MdxAccordionGroup.displayName = 'MdxAccordionGroup';

export { MdxAccordion, MdxAccordionGroup };
